const static_url = document.getElementsByName('static_url')[0].defaultValue;

const static_images = {
  eugdpr: `${static_url}new-ui/assets/EU_GDPR.png`,
  iso27001: `${static_url}new-ui/assets/ISO_27001.png`,
  sally: `${static_url}new-ui/assets/sally.png`,
  sally_shadow: `${static_url}new-ui/assets/sally-shadow.png`,
  sally_dog: `${static_url}new-ui/assets/sally-dog.png`,
  sally_dog_shadow: `${static_url}new-ui/assets/sally-dog-shadow.png`,
  yto_logo: `${static_url}new-ui/assets/yto-logo.png`,
  yto_icon: `${static_url}new-ui/assets/yto-icon.png`,
};

export { static_images };
